import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ROUTES from "../utils/constants/endpoints";

const useAuthRedirect = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (isAuthenticated && [ROUTES.LOGIN, ROUTES.FORGOT_PASSWORD].includes(location.pathname)) {
            navigate(ROUTES.DASHBOARD, { replace: true });
        }

        if (!isAuthenticated && ![ROUTES.LOGIN, ROUTES.FORGOT_PASSWORD].includes(location.pathname)) {
            navigate(ROUTES.LOGIN, { replace: true });
        }
    }, [isAuthenticated, location.pathname, navigate]);

    return isAuthenticated;
};

export default useAuthRedirect;
